import "./NlpChatInput.css";
import React, { useState } from "react";
import RunLogo from "../../../../../assets/run-icon.png"
import SendLogo from "../../../../../assets/send-icon.png"
import AddLogo from "../../../../../assets/add-icon.png"

const NlpChatInput: React.FC = () => {
    const [input, setInput] = useState("");

    return (
        <div className="NlpChatInput">
            <div className="chat-button purple">
                <img src={SendLogo} alt="send" />
            </div>
            <div className="chat-button gold">
                <img src={RunLogo} alt="magic" />
            </div>

            <input
                className="chat-input-field"
                type="text"
                placeholder="אני מצטערת לשמוע, מה הסיבה לעצב?"
                value={input}
                onChange={(e) => setInput(e.target.value)}
                dir="rtl"
            />

            <div className="chat-button purple">
                <img src={AddLogo} alt="plus" />
            </div>
        </div>
    );
};

export default NlpChatInput;